import { render, staticRenderFns } from "./p-thank-you.vue?vue&type=template&id=13a755cc&"
import script from "./p-thank-you.vue?vue&type=script&lang=js&"
export * from "./p-thank-you.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports